import { createAction, props } from '@ngrx/store';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { Paginator } from '../models/bulk.models';

export const LoadErrorLogsCols = createAction(
  '[Bulk Operations: History]: Load Error Logs Columns',
  props<{ displayedColumns: { [label: string]: string } }>(),
);

export const AssignErrorId = createAction(
  '[Bulk Operations: History]: Assign Error Id',
  props<{ importJobId: number }>(),
);

export const LogSuccess = createAction(
  '[Bulk Operations: History]: Log Success',
  props<{ res: QcResponseGrid }>(),
);

export const ProgressChanged = createAction('[Bulk Operations: History]: ProgressChanged');

export const LogFailed = createAction('[Bulk Operations: History]: Log Failed');

export const LogOrderingInit = createAction(
  '[Bulk Operations: History]: Log Sorting Init',
  props<{ orderFieldOptions: string[]; selectedOrder: string }>(),
);

export const LogSortingInit = createAction(
  '[Bulk Operations: History]: Log Ordering Init',
  props<{ sortFieldOptions: string[]; selectedSortField: string }>(),
);

export const LogItemsPerPageChanged = createAction(
  '[Bulk Operations: History]: Log Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);

export const LogOrderingChanged = createAction(
  '[Bulk Operations: History]: Log Order Changed',
  props<{ selectedOrder: string }>(),
);

export const LogSortingChanged = createAction(
  '[Bulk Operations: History]: Log Sorting Changed',
  props<{ selectedSortField: string }>(),
);

export const LogPagingChanged = createAction(
  '[Bulk Operations: History]: Log Paging Changed',
  props<{ paginator: Paginator }>(),
);
